<template>
    <div class="info" v-if="baseInfo != null">
        <div class="row">
            <div class="col-12 col-lg-4">
                <span class="title">آدرس: </span> <span class="text-all">{{baseInfo.Address}}</span>
            </div>
            <div class="col-12 col-lg-3">
                <span class="title">شماره تماس شرکت: </span> <span class="text-all"> <a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo.split('،')[0] }}</a></span>
                <br />
                <span class="title">شماره تماس فروشگاه: </span> <span class="text-all"> <a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo.split('،')[1] }}</a></span>
            </div>
            <div class="col-12 col-lg-3">
                <span class="title">ایمیل: </span><a :href="'mailto:' + baseInfo.Email ">{{ baseInfo.Email }}</a>
            </div>
            <div class="col-12 col-lg-2">
                <div class="socials">
                    <div class="footer-social">
                        <!--<a :href="baseInfo.InstagramLink" :title="' اینستاگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-instagram"></i> اینستاگرام</a>-->
                        <a :href="baseInfo.TelegramLink" class="margin" :title="' تلگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-telegram"></i> تلگرام</a>
                        <a :href="baseInfo.AparatLink" :title="' واتساپ ' + baseInfo.ShopName" target="_blank"><i class="fa fa-whatsapp"></i> واتساپ</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        }
    }
</script>

<style scoped>
    .margin {
        margin:0 5px 0 5px;
    }
    .div-image {
        display: inline-block;
    }
    .text-all {
        font-size: 14px;
        font-weight: bold;
    }
</style>